var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('SectionHeading',{attrs:{"content":_vm.heading.content,"extra_content":_vm.heading.extra}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }